import { defineMessages } from "react-intl";

const messages = defineMessages({
  copy: {
    id: "settings.manageFields.grid.actions.clone",
    defaultMessage: "Create a Copy",
    description: "Header of Copy Field action",
  },
  disabled: {
    id: "settings.manageFields.grid.actions.clone.disabled",
    defaultMessage: "Copying system fields is not allowed",
    description: "Header of disabled Copy Field action",
  },
  successDescription: {
    id: "settings.manageFields.grid.actions.clone.success.description",
    defaultMessage:
      "The type, access rights, and all other settings have be copied to the new field.",
    description: "Success description for Copy field action",
  },
  successEditButtonTitle: {
    id: "settings.manageFields.grid.actions.clone.success.editButtonTitle",
    defaultMessage: "Edit",
    description: "Edit button for success message",
  },
  successMessage: {
    id: "settings.manageFields.grid.actions.clone.success.message",
    defaultMessage: "Custom field copied successfully",
    description: "Success message for copy field action",
  },
});

export default messages;
